import {
  pushChatRoom,
  pushLoadingProgress,
  setAllChatList
} from 'features/messagingChats/messagingChats';
import { Enums } from 'helpers/dropdown-enums';
import { IncreaseProgress } from 'pages/portal/messaging/ChatSplashScreen/SplashScreen';
import store from 'store';
import RTC from '../rtc';
import { chatChanged } from '../services/chatroom-service';

const Subscribe_DefaultQueue = callbacks => {
  RTC().Subscribe({
    channels: ['/defaultqueue'],
    callbacks: callbacks
  });
};

export const Init_DefaultQueue = () => {
  Subscribe_DefaultQueue({
    onSuccess: function (args) {
      IncreaseProgress({
        text: 'Subscribing default queue...',
        count: 10
      });
      console.log('successfully subscribed to default channel: ');
    },
    onReceive: function (args) {
      console.log('routed chat:' + args.getData().chatId);
      var data = args.getData();
      var chatroomByType = chatChanged(data);
      console.log('default queue chatroomByType---', chatroomByType);
      if (
        chatroomByType.includeInSections.length ||
        chatroomByType.excludeInSections.length
      ) {
        // TODO: remove duplication of chat and push to respective chat array by its type
        store.dispatch(pushChatRoom(chatroomByType));
      }
    }
  });
};

export default Subscribe_DefaultQueue;
